<template lang="pug">
form(@submit.prevent="signIn")
  fieldset(:disabled="loading")
    .container
      .wrapper
        .header
          img(src="../../assets/logo.png")
        .body
          .h6.text-primary.mt-2 Bem-vindo(a) ao DentalGO Admin
          form-group.has-icon-left(:validation="$v" field="email" :api-error="error")
            input.form-input(v-model="$v.email.$model" placeholder="E-mail")
            i.form-icon.fas.fa-envelope.primary-color
          form-group.has-icon-left(:validation="$v" field="password" :api-error="error")
            input.form-input(type="password" v-model="$v.password.$model" placeholder="Senha")
            i.form-icon.fas.fa-unlock-alt.primary-color
        .footer
          .signin-container
            button.btn.btn-primary(:disabled="$v.$invalid" :class="{loading}") Entrar
</template>

<script>
import authService from '@/services/auth'
import { required, email, minLength } from 'vuelidate/lib/validators'
import FormGroup from '@/components/form/FormGroup'
import AuthManager from '@/lib/AuthManager'

export default {
  data() {
    return { email: '', password: '', error: null, loading: false }
  },

  components: { FormGroup },

  methods: {
    async signIn() {
      try {
        this.loading = true
        await authService.emailAndPasswordSignIn(this.email, this.password)
        this.$router.push({ name: 'loadSession' })
      } catch (e) {
        this.error = e
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },

  validations: {
    email: { required, email },
    password: { required, minLength: minLength(6) },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../styles/_colors.styl'

form, fieldset
  height 100%

.container
  display flex
  width 100%
  height 100%
  flex-direction column
  justify-content center
  align-items center

  .wrapper
    border-radius 8px
    border 1px solid #dadce0
    padding 20px

    .primary-color
      color primary

    .header
      display flex
      flex-direction column
      align-items center

    .body
      margin 50px 0 30px 0

      .h6.text-primary.mt-2
        text-align center
        margin-bottom 5px

      .has-icon-left .form-input
        padding-left 1.5rem

      .form-icon
        top 1.1rem

    .footer
      display flex
      flex-direction column
      padding-bottom 0

      .signin-container
        display flex
        justify-content center
        margin 10px 0

      .recover-password-button
        margin-bottom -10px
        font-size 14px
        color #999
</style>
